import type { DateInput } from './types';

/**
 * Coerces a formattable input to a valid `Date`, or null when it is not one.
 *
 * The null return is the whole point. `new Date(...)` returns an INVALID date
 * rather than throwing for garbage input, and every date-fns formatter then
 * throws `RangeError` on it. A malformed value from the server would therefore
 * crash a render instead of degrading one field — so validity is established
 * once, here, and every formatter decides what to do with a null before it
 * reaches date-fns.
 */
export function toDateOrNull(value: DateInput): Date | null {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}
